import { React, useEffect } from 'react'

const Discord = () => {
    useEffect(() => {
        // Set background image for the discord page
        document.body.style.backgroundImage = 'url("/images/discordBkg.jpg")';

        // Clean up function to reset background image on unmount
        return () => {
            document.body.style.backgroundImage = 'none';
        };
    }, []);

    return (
        <div className="flex flex-col items-center justify-center h-screen text-center">
            <p className="mb-4 w-60">Want more wisdom? Come and check out Discord Buddha, a friendly community welcoming all traditions of buddhism, dedicated to spreading the wisdom of the Buddha Dharma far and wide.</p>
            <a 
                href="https://discord.gg/SBEFTx24E4" 
                target="_blank" 
                rel="noopener noreferrer"
                className="bg-purple-600 text-white font-bold py-2 px-4 rounded"
            >
                Join Discord
            </a>
        </div>
    )
}

export default Discord